import { render, staticRenderFns } from "./contingency3.vue?vue&type=template&id=23a92cd5&scoped=true&"
import script from "./contingency3.vue?vue&type=script&lang=js&"
export * from "./contingency3.vue?vue&type=script&lang=js&"
import style0 from "./contingency3.vue?vue&type=style&index=0&id=23a92cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a92cd5",
  null
  
)

export default component.exports